import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'cad-group-name',
  imports: [ReactiveFormsModule],
  templateUrl: './group-name.html',
  styleUrl: './group-name.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupName {
  expanded = signal<boolean>(true);

  private createSparkCampaignService = inject(CreateSparkCampaign);

  readonly adGroupNameControl = new FormControl<string>('', { nonNullable: true });

  constructor() {
    const initial = this.createSparkCampaignService.adGroupName();
    this.adGroupNameControl.setValue(initial ?? '', { emitEvent: false });
    this.adGroupNameControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((value) => {
      const trimmed = value.trim();
      this.createSparkCampaignService.adGroupName.set(trimmed.length > 0 ? trimmed : undefined);
    });
  }
}
